import { useMemo } from "react";
import { cn, Tooltip } from "ui";
import {
  formatDate,
  formatRelativeDate,
  formatToUtcDate,
} from "../utils/formatDate";

export default function DateDisplay({
  date,
  className,
  format,
}: {
  date: Date | string;
  className?: string;
  format?: string;
}) {
  const dateObj = useMemo(
    () => (typeof date === "string" ? new Date(date) : date),
    [date]
  );
  return (
    <Tooltip size="sm" content={formatToUtcDate(dateObj)}>
      <span
        className={cn(
          "underline decoration-dotted underline-offset-2",
          className
        )}
      >
        {formatDate(dateObj, format)} ({formatRelativeDate(dateObj)})
      </span>
    </Tooltip>
  );
}
